import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { fetchPopularJobCategoriesList } from "./PopularJobCategoriesListAPI"

const initialState = {
  data: [],
  loading: false,
  error: null,
  currentPage: 1,
}

export const fetchPopularJobCategoriesListAsync = createAsyncThunk(
  "PopularJobCategoriesList/fetch",
  async ({ uuid, page = 1, perPage = 15 }, { rejectWithValue }) => {
    try {
      const data = await fetchPopularJobCategoriesList(uuid, page, perPage)

      const resp = data?.response
      if (!resp) {
        throw new Error("Invalid response structure")
      }
      return {
        jobs: resp.data, // The array of job data
        totalJobs: resp.total,
        currentPage: page,
      }
    } catch (error) {
      return rejectWithValue(error.message)
    }
  },
)

const PopularJobCategoriesListSlice = createSlice({
  name: "PopularJobCategoriesList",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPopularJobCategoriesListAsync.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchPopularJobCategoriesListAsync.fulfilled, (state, action) => {
        state.loading = false
        state.data = action.payload
        state.currentPage = action.payload.currentPage
        state.error = null
      })
      .addCase(fetchPopularJobCategoriesListAsync.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload || action.error.message
      })
  },
})

export const selectPopularJobCategoriesList = (state) => state.popularJobCategoriesList.data.jobs
export const selectPopularJobCategoriesTotal = (state) => state.popularJobCategoriesList.data.totalJobs
export const selectCurrentPage = (state) => state.popularJobCategoriesList.currentPage

export default PopularJobCategoriesListSlice.reducer
